var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Customer } from './Model';
export default class default_1 {
    constructor() {
        this.customers = [];
        this.loaded = false;
        this.set = (customers) => {
            this.customers = customers.map(customer => new Customer(customer));
            this.loaded = true;
        };
        this.push = (customer) => {
            this.customers.push(new Customer(customer));
        };
        this.replace = (customer) => {
            this.customers.splice(this.customers.findIndex(f => f.id === customer.id), 1, customer);
        };
        this.pull = (customer) => {
            this.customers.splice(this.customers.findIndex(a => a.id === customer.id), 1);
        };
    }
    read(id) {
        if (id)
            return api.get('customer/' + id).then(customer => new Customer(customer));
        return api.get('customer').then(this.set);
    }
    create(customer) {
        return api.post('customer', customer).then(this.push);
    }
    update(id, customer) {
        return api.put('customer/' + id, customer).then(this.replace);
    }
    disable(id, disabled) {
        return api.patch('customer/' + id, { disabled }).then(this.pull);
    }
}
__decorate([
    observable
], default_1.prototype, "customers", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);
__decorate([
    action
], default_1.prototype, "pull", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Customers/Store.ts
// module id = 332
// module chunks = 0